import React from "react";

/**
 * Displays Latitude and Longitude Coordinates
 * @component
 */
export default function ConsoleCoordinates() {

  return (
    <table id="coordContainer">
      <thead>
        <tr>
          <th>Latitude</th>
          <th>Longitude</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td id="latCoordinateDisplay">---.---</td>
          <td id="lonCoordinateDisplay">---.---</td>
        </tr>
      </tbody>
    </table>
  );
}
